import { red } from '../red';

export const critical = {
  primary: red[600],
  500: red[500],
  400: 'hsla(15, 100%, 74%, 1)',
  300: 'hsla(15, 100%, 80%, 1)',
  200: 'hsla(15, 100%, 86%, 1)',
  100: red[100],
  50: red[50],
  30: 'hsla(15, 100%, 94%, 0.5)',
};
